module.exports = "/_next/static/images/8-9dc8c2bbdc6d10ff13de23bef915ed0d.png";